import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.category;

export const categoriesListSelector = createSelector(getState, (state) => state.categories);
export const categoriesMetaDataSelector = createSelector(getState, (state) => state.metaData);

export const isLoadingCreateCategorySelector = createSelector(
  getState,
  (state) => state.isLoadingCreateCategory
);
export const isLoadingFetchCategoriesSelector = createSelector(
  getState,
  (state) => state.isLoadingFetchCategories
);
export const isLoadingUpdateCategorySelector = createSelector(
  getState,
  (state) => state.isLoadingUpdateCategory
);
export const isLoadingDeleteCategorySelector = createSelector(
  getState,
  (state) => state.isLoadingDeleteCategory
);
